import { render, staticRenderFns } from "./LastOrdersModal.vue?vue&type=template&id=c48ee560&"
import script from "./LastOrdersModal.vue?vue&type=script&lang=js&"
export * from "./LastOrdersModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports